module.exports = __webpack_public_path__ + "static/img/background_sebastian_final_iphone_415x745.80d5e7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background_sebastian_final_iphone_415x745.jpg
// module id = WpNe
// module chunks = 0